import { ArrowRightOutlined } from '@ant-design/icons';
import { theme } from 'antd';
import { Avatar, Button, Card, Divider, Flex, Typography } from 'zui/Antd';

const { Title, Text } = Typography;

const AccessCardHome = ({ title = '0', subtitle = 'Label', icon, onClick }) => {
	//✅ Hooks
	const {
		token: { paddingSM, colorPrimary, colorBorder, fontSizeSM, fontWeightStrong, colorIcon, colorTextLabel }
	} = theme.useToken();

	return (
		<Card
			style={{
				borderRadius: 12,
				width: '100%',
				border: `1px solid ${colorBorder}`
			}}
			styles={{ body: { padding: paddingSM } }}
		>
			<Flex vertical>
				<Flex align='center' gap={16}>
					<Avatar size={54} icon={icon} style={{ backgroundColor: colorPrimary }} shape='square' />

					<Flex vertical>
						<Title level={2} style={{ margin: 0, lineHeight: '38px' }}>
							{title}
						</Title>
						<Text style={{ fontSize: fontSizeSM, fontWeight: fontWeightStrong, lineHeight: '20px' }}>
							{subtitle}
						</Text>
					</Flex>
				</Flex>

				<Divider style={{ margin: '16px 0', background: colorBorder }} />

				<Flex>
					<Button
						icon={<ArrowRightOutlined style={{ color: colorIcon }} />}
						type='text'
						style={{
							color: colorTextLabel,
							overflow: 'hidden',
							textOverflow: 'ellipsis'
						}}
						onClick={onClick}
					>
						View {subtitle}
					</Button>
				</Flex>
			</Flex>
		</Card>
	);
};

export default AccessCardHome;
